import { render, staticRenderFns } from "./ErrorOptionView.vue?vue&type=template&id=0696b3dc&scoped=true&"
import script from "./ErrorOptionView.vue?vue&type=script&lang=js&"
export * from "./ErrorOptionView.vue?vue&type=script&lang=js&"
import style0 from "./ErrorOptionView.vue?vue&type=style&index=0&id=0696b3dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0696b3dc",
  null
  
)

export default component.exports